import { Building2, Hammer, Home, BrickWall, Layers, PaintBucket, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    title: "Obra Nueva y Edificación",
    description:
      "Ejecución completa de proyectos de edificación desde la cimentación hasta los acabados finales, con seguridad estructural y máxima calidad.",
    Icon: Building2,
    number: "01",
  },
  {
    title: "Reformas Integrales",
    description:
      "Transformación total de viviendas, locales comerciales, cocinas y baños. Gestionamos tu proyecto de principio a fin.",
    Icon: Hammer,
    number: "02",
  },
  {
    title: "Rehabilitación de Edificios",
    description:
      "Restauración y consolidación de inmuebles, refuerzo estructural y renovación de zonas comunitarias.",
    Icon: Home,
    number: "03",
  },
  {
    title: "Albañilería General",
    description:
      "Trabajos de albañilería, tabiquería, enfoscados, lucidos y reformas parciales con máxima precisión y firmeza.",
    Icon: BrickWall,
    number: "04",
  },
  {
    title: "Solados y Alicatados",
    description:
      "Instalación profesional de pavimentos, gres porcelánico, cerámicas y revestimientos con acabados impecables.",
    Icon: Layers,
    number: "05",
  },
  {
    title: "Todo Tipo de Fachadas",
    description:
      "Expertos en aislamiento térmico SATE, pintura exterior, reparación de grietas y revestimiento de fachadas.",
    Icon: PaintBucket,
    number: "06",
  },
];

export default function Services() {
  return (
    <section id="servicios" data-testid="services-section" className="relative py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#F26522]/10 text-[#D95212] text-xs font-mono-accent uppercase tracking-[0.18em] mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#F26522]" />
            Nuestros Servicios
          </div>
          <h2
            data-testid="services-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1528] tracking-tight"
          >
            Servicios profesionales para{" "}
            <span className="text-[#F26522]">cada tipo de obra</span>.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Desde la primera piedra hasta el último acabado. Cubrimos todo el ciclo de tu proyecto
            con profesionales de oficio y materiales de primera categoría.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.number}
              data-testid={`service-card-${s.number}`}
              className="lift group relative bg-white border border-slate-200 rounded-2xl p-7 overflow-hidden"
            >
              {/* Big index number */}
              <div className="absolute -top-3 right-4 font-display font-black text-[110px] leading-none text-slate-100 select-none group-hover:text-[#F26522]/10 transition-colors">
                {s.number}
              </div>

              <div className="relative">
                <div className="w-14 h-14 rounded-xl bg-[#0B1528] text-white flex items-center justify-center mb-5 group-hover:bg-[#F26522] transition-colors">
                  <s.Icon className="w-6 h-6" strokeWidth={2} />
                </div>

                <h3 className="font-display text-xl font-bold text-[#0B1528] mb-2">
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.description}</p>

                <div className="mt-5 pt-5 border-t border-slate-100 flex items-center justify-between">
                  <span className="text-xs font-mono-accent uppercase tracking-[0.15em] text-slate-400">
                    Servicio {s.number}
                  </span>
                  <a
                    href="#contacto"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0B1528] group-hover:text-[#F26522] transition-colors"
                  >
                    Consultar
                    <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
